export const PATH_PARAMETERS_APPLICATIONS = "/parameters/applications";
export const PATH_PARAMETERS_APPLICATIONS_THIRD_PART_APP = `${PATH_PARAMETERS_APPLICATIONS}/third-part-app`;
export const PATH_PARAMETERS_APPLICATIONS_THIRD_PART_APP_CLIENT_ID = `${PATH_PARAMETERS_APPLICATIONS_THIRD_PART_APP}/:clientId`;
